import { formatProgress } from './utils';

export const renderNonTask = (task, t) => `
  <span className="vertical-center-dates">
    <span className="column-disabled">${formatProgress(isNaN(task.progress_fix) ? task.progress : task.progress_fix, t('lang'))}</span>
  </span>
`;
